import { Box, IconButton, Modal, Stack, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import ReactPlayer from "react-player";
import HolaVidaLogo from "src/assets/HolaVidaLogo";
import { theme } from "src/assets/theme";
import { useIsMobile } from "src/hooks/useIsMobile";
import WhiteCard from "src/shared/components/WhiteCard";
import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import { Languages } from "src/api/types";

interface Props {
  language: Languages;
}

const desktopSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 640,
  minHeight: "fit-content",
  maxHeight: "90%",
  overflow: "auto",
  outline: "none",
  borderRadius: 2,
  padding: 2,
  zIndex: 1300,
};

const mobileSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  width: "80%",
  borderRadius: 2,
  overflow: "scroll",
  p: 2,
  zIndex: 1300,
};

const WelcomeVideo = ({ language }: Props) => {
  const isMobile = useIsMobile();
  const [play, setPlay] = useState<boolean>(false);

  const videoLink = useMemo(
    () =>
      language === "es"
        ? `https://vimeo.com/1200460918?share=copy#t=0`
        : "https://vimeo.com/1200441762?share=copy#t=0",
    [language],
  );

  const handlePlayVideo = useCallback(() => {
    setPlay((p) => !p);
  }, [setPlay]);

  return (
    <>
      <WhiteCard
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",

          p: 2,
        }}
        onClick={handlePlayVideo}
      >
        <Stack alignItems="center" justifyContent="center" spacing={1}>
          <Typography
            variant="h4"
            fontWeight={600}
            color={theme.palette.primary.main}
          >
            Welcome to
          </Typography>
          <HolaVidaLogo sx={{ height: "110px", width: "270px" }} />
        </Stack>
        <IconButton
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "rgba(255,255,255,0.8)",
            "&:hover": { bgcolor: "rgba(255,255,255,0.9)" },
            color: theme.palette.secondary.main,
            borderRadius: "50%",
            p: 1,
            zIndex: 1,
          }}
        >
          <SmartDisplayOutlinedIcon sx={{ fontSize: "4rem" }} />
        </IconButton>
      </WhiteCard>
      <Modal
        open={play}
        onClose={handlePlayVideo}
        disableAutoFocus
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        }}
      >
        <Box sx={isMobile ? mobileSx : desktopSx}>
          <Box
            sx={{
              aspectRatio: "16/9",
              width: "100%",
              cursor: "pointer",
            }}
          >
            <ReactPlayer
              url={videoLink}
              width="100%"
              height="100%"
              controls
              playing={true}
              pip
              allowFullScreen
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default WelcomeVideo;
